import * as THREE from 'three';
import { ColyseusSession } from '../client/network/ColyseusSession.js';
import type { PlayerController } from './PlayerController.js';
import { FpsCharacterModel } from './FpsCharacterModel.js';

export class FpsNetwork {
  private session = new ColyseusSession();
  private remotePlayers = new Map<string, FpsCharacterModel>();
  private updateTimer = 0;

  constructor(private scene: THREE.Scene, private player: PlayerController) {
    this.session.on('state', (state) => this.onStateUpdate(state));
    this.session.on('remote_fire', (payload) => this.onRemoteFire(payload));
  }

  public async connect() {
    try {
      await this.session.connect({ playerName: 'FPS_Player' });
      console.log('Connected to multiplayer server.');
    } catch (err) {
      console.warn('Failed to connect to Colyseus server:', err);
    }
  }

  public update(dt: number) {
    if (!this.session.room) return;

    this.updateTimer += dt;
    if (this.updateTimer > 0.1) {
      this.updateTimer = 0;
      const pos = this.player.body.position;
      const rot = this.player.yawObject.rotation.y;
      this.session.send('move', { x: pos.x, y: pos.y, z: pos.z, rotation: rot });
    }
  }

  private onStateUpdate(state: any) {
    if (!state.remotePlayers) return;

    const seenIds = new Set<string>();

    for (const rp of state.remotePlayers) {
      seenIds.add(rp.sessionId);
      let model = this.remotePlayers.get(rp.sessionId);
      if (!model) {
        model = new FpsCharacterModel(this.scene, Math.random());
        model.setName(rp.name ?? rp.sessionId);
        this.remotePlayers.set(rp.sessionId, model);
      }

      // Server (x, y) → 3D (x, 0, z)
      model.group.position.set(rp.x, 0, rp.y);
      const vel = new THREE.Vector3(0, 0, 0);
      model.update(0.016, vel, true, rp.rotation ?? 0);
    }

    for (const [id, model] of this.remotePlayers.entries()) {
      if (!seenIds.has(id)) {
        model.dispose();
        this.remotePlayers.delete(id);
      }
    }
  }

  private onRemoteFire(_payload: any) {
    // Spawn tracers from remote player
  }
}
